import React, { FC } from 'react';

import { IWidget, ParsedEntry } from '@/contentful/types';

import {
  IncidentClassification,
  IncidentSubClassification,
} from '@models/Incident';

import { TitleDescriptionIncidentForm } from '../components/TitleDescriptionIncidentForm';
import { ContractsFormKey } from '../MessageForms.types';

import { ContractQuestionForm } from './ContractQuestionForm';

export const contractForms: Record<
  ContractsFormKey,
  FC<ParsedEntry<IWidget>>
> = {
  [ContractsFormKey.CONTRACT_QUESTION]: ContractQuestionForm,
  [ContractsFormKey.CONTRACT_NEW_PARTY]: ({ customTranslations }) => (
    <TitleDescriptionIncidentForm
      incidentKind="ContractsNewParty"
      translations={customTranslations}
      classifications={{
        classification: IncidentClassification.CONTRACTS,
        subClassification: IncidentSubClassification.NEW_PARTY,
      }}
    />
  ),
  [ContractsFormKey.CONTRACT_NEW_RESIDENT]: ({ customTranslations }) => (
    <TitleDescriptionIncidentForm
      incidentKind="ContractsNewResident"
      translations={customTranslations}
      classifications={{
        classification: IncidentClassification.CONTRACTS,
        subClassification: IncidentSubClassification.NEW_RESIDENT,
      }}
    />
  ),
  [ContractsFormKey.CONTRACT_TRANSFER]: ({ customTranslations }) => (
    <TitleDescriptionIncidentForm
      incidentKind="ContractsTransfer"
      translations={customTranslations}
      classifications={{
        classification: IncidentClassification.CONTRACTS,
        subClassification: IncidentSubClassification.CONTRACT_TRANSFER,
      }}
    />
  ),
};
